module.exports = __webpack_public_path__ + "images/emoji/dart.281b91d014bb2d879edd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/dart.png
// module id = 6h8M
// module chunks = 2